module.exports = __webpack_public_path__ + "static/media/35.d54011fa.jpg";